import { useContext, useState } from "react";
import Name from "./name";
import List from "./List";
import Export from "./Export";
import RecipeContext from "./store/recipe-context";

function ExportRecipe() {
  const recipeContext = useContext(RecipeContext);

  return (
    <div>
      <Name />
      <List
        items={recipeContext.ingredients}
        add={recipeContext.addIngredient}
        remove={recipeContext.removeIngredient}
        move={recipeContext.moveIngredient}
        listName={"Ingredient"}
        ingredientRow={true}
      />
      <List
        items={recipeContext.miseEnPlace}
        add={recipeContext.addMiseEnPlace}
        remove={recipeContext.removeMiseEnPlace}
        move={recipeContext.moveMiseEnPlace}
        listName={"Mise En Place"}
        ingredientRow={false}
      />
      <List
        items={recipeContext.method}
        add={recipeContext.addMethod}
        remove={recipeContext.removeMethod}
        move={recipeContext.moveMethod}
        listName={"Method"}
        ingredientRow={false}
      />
      <List
        items={recipeContext.notes}
        add={recipeContext.addNote}
        remove={recipeContext.removeNote}
        move={recipeContext.moveNote}
        listName={"Notes"}
        ingredientRow={false}
      />
      <Export />
    </div>
  );
}

export default ExportRecipe;
